module.exports = __webpack_public_path__ + "static/Papa_Song_Short_Version_Instrumental.d1913f23.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/data/Papa_Song_Short_Version_Instrumental.mp3
// module id = 214
// module chunks = 35783957827783